import React, { useEffect, useState } from 'react'
import { CAlert, CButton, CModal, CModalBody, CModalFooter, CModalHeader, CModalTitle, CSpinner } from '@coreui/react'
import { aiAdminRequest } from '../../services/aiAdminActions'
import { useUI } from '../../shared/ui/UIProvider'

function errorMessage(error) {
  return error?.response?.data?.message || error?.response?.data?.error || error?.message || 'No se pudo guardar la disponibilidad'
}

export default function ScriptGlobalAvailabilityModal({ script, onClose }) {
  const { toast } = useUI()
  const [enabled, setEnabled] = useState(false)
  const [initial, setInitial] = useState(false)
  const [loading, setLoading] = useState(true)
  const [saving, setSaving] = useState(false)
  const [error, setError] = useState('')

  useEffect(() => {
    let active = true
    setLoading(true)
    setError('')
    aiAdminRequest('GET', { resource: 'custom-scripts', action: 'global-availability', uuid: script.uuid })
      .then((response) => {
        if (response?.ok !== true || typeof response.enabled !== 'boolean') throw new Error('No se pudo leer la disponibilidad global')
        if (!active) return
        setEnabled(response.enabled)
        setInitial(response.enabled)
        setLoading(false)
      })
      .catch((err) => { if (active) setError(errorMessage(err)) })
    return () => { active = false }
  }, [script.uuid])

  async function save() {
    setSaving(true)
    setError('')
    try {
      const response = await aiAdminRequest('POST', { resource: 'custom-scripts', action: 'set-global-availability' }, { uuid: script.uuid, enabled })
      if (response?.ok !== true || response.enabled !== enabled) throw new Error('No se pudo confirmar la disponibilidad global')
      toast(enabled ? 'Script disponible para todas las agencias' : 'Disponibilidad global desactivada', 'success')
      onClose()
    } catch (err) {
      setError(errorMessage(err))
    } finally {
      setSaving(false)
    }
  }

  return (
    <CModal visible alignment="center" onClose={() => { if (!saving) onClose() }}>
      <CModalHeader closeButton={!saving}><CModalTitle>Disponibilidad global</CModalTitle></CModalHeader>
      <CModalBody>
        <p><strong>{script.name}</strong></p>
        {error ? <CAlert color="danger">{error}</CAlert> : null}
        {loading && !error ? <CSpinner size="sm" /> : null}
        <label className="script-global-availability-toggle" htmlFor="script-global-availability">
          <input
            type="checkbox"
            id="script-global-availability"
            checked={enabled}
            disabled={loading || saving}
            onChange={(event) => setEnabled(event.target.checked)}
          />
          <span>Disponible para todas las agencias</span>
        </label>
      </CModalBody>
      <CModalFooter>
        <CButton color="light" disabled={saving} onClick={onClose}>Cancelar</CButton>
        <CButton color="success" className="btn-brand" disabled={loading || saving || enabled === initial} onClick={save}>
          {saving ? <CSpinner size="sm" /> : 'Guardar cambios'}
        </CButton>
      </CModalFooter>
    </CModal>
  )
}
